module.exports = __webpack_public_path__ + "static/media/john-hoff.6f6d83b1.jpg";